import Vue from 'vue'
import App from './App.vue'

// Networking
import Resource from 'vue-resource'
// Routing & localization
import router from './router'
import vueHeadful from 'vue-headful';
import { Trans } from './localization/Translation.js'
import { i18n } from './localization/i18n.js'
// Disqus
import VueDisqus from 'vue-disqus'
// UI
import VueMq from 'vue-mq'
// Form
import VeeValidate from 'vee-validate';
import VueTextareaAutosize from 'vue-textarea-autosize'
//Analytics
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'

Vue.use(Resource)

Vue.component('vue-headful', vueHeadful);
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
 
Vue.config.productionTip = false
Vue.use(VueMq, {
  breakpoints: {
    tiny: 451,
    verySmall: 501,
    small: 981,
    medium: 1280,
    large: Infinity,
  }
})

Vue.use(VueDisqus)
Vue.use(VueTextareaAutosize)
Vue.use(VeeValidate, {
  events: 'blur'
})

Vue.directive('title', {
  inserted: (el, binding) => document.title = binding.value + " - Fernando Mata",
  update: (el, binding) => document.title = binding.value + " - Fernando Mata"
})

Vue.use(VueAnalytics, {
  id: 'UA-59831602-1',
  router
})

Vue.use(VueMeta)


router.beforeEach((to, from, next) => {
  if (!to.meta.supportedLanguages) {
    return next()
  }
  
  if (to.meta.supportedLanguages.includes(to.params.lang)) {
    return next()
  }
  
  return next("/" + to.params.lang + "/404")
})

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
